export { ActivitiesTaskComponent } from '@shared/layout/header/activities/activities-task/activities-task.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-task/index.ts